export default __webpack_public_path__ + "static/36-fit-09e9b78b0a12d90de7689168b7265b6f.png";